import { Footer } from '../homepage/Footer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContactMessages } from './ContactPage.messages';
import { PageSeo } from '../seo/PageSeo';
import { breadcrumbSchema } from '../seo/schemas';
import './static-page.css';

export const ContactPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
    <PageSeo
      path="/contact"
      localized
      titleKey="seo.contact.title"
      descriptionKey="seo.contact.description"
      ogImage="/og/og-default.png"
      jsonLd={[breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Contact', path: '/contact' }])]}
    />
    <div className="page-wrapper"><div className="static-page">
      <h1>{t(ContactMessages.PAGE_TITLE)}</h1>
      <p className="page-subtitle">{t(ContactMessages.SUBTITLE)}</p>

      <h2>{t(ContactMessages.GENERAL_TITLE)}</h2>
      <p>{t(ContactMessages.GENERAL_DESC)}<br/>
        <a href="mailto:hello@localingos.com">hello@localingos.com</a>
      </p>

      <h2>{t(ContactMessages.SUPPORT_TITLE)}</h2>
      <p>{t(ContactMessages.SUPPORT_DESC)}<br/>
        <a href="mailto:support@localingos.com">support@localingos.com</a>
      </p>

      <h2>{t(ContactMessages.BILLING_TITLE)}</h2>
      <p>{t(ContactMessages.BILLING_DESC)}<br/>
        <a href="mailto:billing@localingos.com">billing@localingos.com</a>
      </p>

      <h2>{t(ContactMessages.SECURITY_TITLE)}</h2>
      <p>{t(ContactMessages.SECURITY_DESC)}<br/>
        <a href="mailto:security@localingos.com">security@localingos.com</a>
      </p>
    </div>
    <Footer />
    </div>
    </>
  );
};
